/**
 * Sticky Add to Cart
 * Affiche une barre fixe en bas de page quand le bouton principal n'est plus visible
 */

class StickyAddToCart {
  constructor() {
    this.stickyBar = document.querySelector('.sticky-add-to-cart');
    if (!this.stickyBar) return;

    this.sectionId = this.stickyBar.dataset.sectionId;
    this.mainButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
    this.mainVariantPicker = document.querySelector(`#product-form-${this.sectionId} select[name="id"]`);
    this.stickyVariantSelect = document.getElementById(`StickyVariantSelect-${this.sectionId}`);

    this.init();
  }

  init() {
    // Observer pour détecter la visibilité du bouton principal
    this.setupIntersectionObserver();

    // Synchroniser la sélection de variante
    if (this.mainVariantPicker && this.stickyVariantSelect) {
      this.syncVariantSelects();
    }

    // Écouter les changements de variante sur la page principale
    this.listenToMainFormChanges();
  }

  setupIntersectionObserver() {
    if (!this.mainButton) return;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Si le bouton principal n'est PAS visible, afficher le sticky
        if (!entry.isIntersecting) {
          this.showStickyBar();
        } else {
          this.hideStickyBar();
        }
      });
    }, options);

    observer.observe(this.mainButton);
  }

  showStickyBar() {
    if (this.stickyBar) {
      this.stickyBar.style.display = 'block';
      // Petit délai pour l'animation
      setTimeout(() => {
        this.stickyBar.classList.add('is-visible');
      }, 10);
    }
  }

  hideStickyBar() {
    if (this.stickyBar) {
      this.stickyBar.classList.remove('is-visible');
      // Masquer complètement après l'animation
      setTimeout(() => {
        if (!this.stickyBar.classList.contains('is-visible')) {
          this.stickyBar.style.display = 'none';
        }
      }, 300);
    }
  }

  syncVariantSelects() {
    // Synchroniser le sticky select avec le main select
    this.stickyVariantSelect.addEventListener('change', (e) => {
      if (this.mainVariantPicker) {
        this.mainVariantPicker.value = e.target.value;
        this.mainVariantPicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Synchroniser le main select avec le sticky select
    this.mainVariantPicker.addEventListener('change', (e) => {
      if (this.stickyVariantSelect) {
        this.stickyVariantSelect.value = e.target.value;
      }
    });
  }

  listenToMainFormChanges() {
    // Écouter les événements de changement de variante pour mettre à jour le bouton sticky
    document.addEventListener('variant:change', (event) => {
      this.updateStickyButton(event.detail);
    });

    // Écouter les changements dans le formulaire principal
    const mainForm = document.getElementById(`product-form-${this.sectionId}`);
    if (mainForm) {
      mainForm.addEventListener('change', () => {
        this.updateButtonFromMainForm();
      });
    }
  }

  updateStickyButton(variantData) {
    const stickyButton = this.stickyBar.querySelector('.sticky-add-to-cart__button');
    if (!stickyButton) return;

    if (variantData && !variantData.available) {
      stickyButton.setAttribute('disabled', 'disabled');
      stickyButton.querySelector('span').textContent =
        stickyButton.dataset.soldOutText || 'Épuisé';
    } else {
      stickyButton.removeAttribute('disabled');
      stickyButton.querySelector('span').textContent =
        stickyButton.dataset.addToCartText || 'Ajouter au panier';
    }
  }

  updateButtonFromMainForm() {
    const stickyButton = this.stickyBar.querySelector('.sticky-add-to-cart__button');
    if (!stickyButton || !this.mainButton) return;

    // Copier l'état du bouton principal
    if (this.mainButton.hasAttribute('disabled')) {
      stickyButton.setAttribute('disabled', 'disabled');
    } else {
      stickyButton.removeAttribute('disabled');
    }

    // Copier le texte du bouton principal
    const mainButtonText = this.mainButton.querySelector('span');
    const stickyButtonText = stickyButton.querySelector('span');
    if (mainButtonText && stickyButtonText) {
      stickyButtonText.textContent = mainButtonText.textContent;
    }
  }
}

// Initialiser quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddToCart();
  });
} else {
  new StickyAddToCart();
}
